import React, { useEffect } from "react";
import styles from "./SecuritySettings.module.css";
import Header from "../../Header/Header";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import config from "../../../config";
import SettingHeader from "../../../components/SettingPageHeader/SettingHeader";

const signInOptions = [
    {
        text: "Change Password",
        icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/44b2db4fb5370f25abaf0ad1d1034731f7ff8d2fe68e93638675db7ca67844f1?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625",
        link: "/change-password",
    },
    // {
    //   text: "Two-factor authentication",
    //   icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/0b4975b3cdfe312200958a9d78cb02a05060c2e65a2dc5b03f82375e54fe7657?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625",
    // },
    {
        text: "Change Email",
        icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/8b27e4a92120fc7350bf928681094204e6df3e347eea1034462e1f070030ddaa?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625",
        link: "/change-email",
    },
];

function SecuritySettings() {
    const navigate = useNavigate(); // Initialize the navigate function
    useEffect(() => {
        document.title = `Sign In & Security | ${config.get("COMPANY_NAME")}`;
    }, []);
    return (
        <>
            <Header title="Sign In & Security" />
            <main className={`${styles.container} tw-h-screen tw-bg-background_color `}>
                <SettingHeader title="Sign In & Security" />
                <div className={`${styles.mainContent} tw-p-[20px]`}>
                    <div className={styles.settingsGroup}>
                        {/* Directly Implementing Sign In & recovery Section */}
                        <section className={styles.settingsSection}>
                            <header className={styles.sectionHeader}>
                                <h2 className="tw-text-[18px] tw-font-semibold">Sign In & Security</h2>
                                <p className={styles.sectionDescription}>Manage your passwords, sign-in preferences, and recovery methods</p>
                            </header>
                            <nav className={styles.optionsList}>
                                <ul>
                                    {signInOptions.map((option, index) => (
                                        <li key={index}>
                                            <button onClick={() => navigate(option.link)} className={styles.optionButton}>
                                                <span className={styles.optionText}>{option.text}</span>
                                                <img src={option.icon} alt="" className={styles.arrowIcon} />
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </section>

                        {/* Directly Implementing Security Checks Section */}
                        {/* <section className={styles.settingsSection}>
                            <header className={styles.sectionHeader}>
                                <h2 className={styles.sectionTitle}>Security Checks</h2>
                                <p className={styles.sectionDescription}>Review devices and emails related to your account's security</p>
                            </header>
                            <nav className={styles.optionsList}>
                                <ul>
                                    {securityOptions.map((option, index) => (
                                        <li key={index}>
                                            <button className={styles.optionButton}>
                                                <span className={styles.optionText}>{option.text}</span>
                                                <img src={option.icon} alt="" className={styles.arrowIcon} />
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </section> */}
                    </div>
                </div>
            </main>
        </>
    );
}

export default SecuritySettings;
